import React, { useRef } from "react";

/**
 * Text input with a clear button shown when value is non-empty.
 */
export default function ClearableInput({
  type = "text",
  value = "",
  onChange,
  placeholder = "",
  className = "",
  inputClassName = "",
  disabled = false,
  onClear,
  inputProps = {},
  buttonAriaLabel = "Clear",
}) {
  const inputRef = useRef(null);
  const hasValue = (value ?? "").length > 0;

  const handleClear = (e) => {
    e.preventDefault();
    if (disabled) return;
    onChange?.({ target: { value: "" } });
    onClear?.();
    // focus back to input after clearing
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  return (
    <div className={`relative ${className}`}>
      <input
        ref={inputRef}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`h-9 w-full rounded-lg border px-3 pr-8 control-text outline-none focus:ring-2 focus:ring-primary ${disabled ? "opacity-60 cursor-not-allowed" : ""} ${inputClassName}`}
        {...inputProps}
      />
      {hasValue && !disabled && (
        <button
          type="button"
          onClick={handleClear}
          aria-label={buttonAriaLabel}
          title={buttonAriaLabel}
          className="absolute right-2 top-1/2 -translate-y-1/2 h-6 w-6 rounded-full text-gray-500 hover:text-gray-700 flex items-center justify-center"
        >
          <span aria-hidden>×</span>
        </button>
      )}
    </div>
  );
}
